import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ConsoleErrorLogService } from './console-error-log.service';

/**
 * Records every uncaught error into the diagnostics buffer, then hands it back to Angular so the
 * console output developers rely on is unchanged.
 *
 * One `ErrorHandler` is enough to cover `window.error`, `unhandledrejection` and errors thrown
 * inside Angular: `provideBrowserGlobalErrorListeners()` (already registered in `web-app.config.ts`)
 * routes the first two here. No extra `addEventListener` is needed -- and adding one would double
 * every entry.
 */
@Injectable()
export class TelemetryErrorHandler extends ErrorHandler {
  private readonly consoleErrorLog = inject(ConsoleErrorLogService);

  public override handleError(error: unknown): void {
    this.consoleErrorLog.recordThrownError(error);
    // Angular's default handler logs through `console.error`, which the console patch would
    // otherwise record as a second entry for the same throw.
    this.consoleErrorLog.runWithoutCapture(() => super.handleError(error));
  }
}
